const $faqQuery = document.querySelectorAll('.faq__query') ?? false;

const init = () => {
	if (!$faqQuery) {
		return;
	}

	$faqQuery.forEach((query) => {
		query.addEventListener('click', (e) => {
			const point = e.target.closest('.faq__point');
			const answer = point.querySelector('.faq__answer');
			const content = point.querySelector('.faq__answer-content');

			if (point.classList.contains('is-active')) {
				point.classList.remove('is-active');
				answer.style.height = 0;
			} else {
				point.classList.add('is-active');
				answer.style.height = `${content.offsetHeight}px`;
			}
		});
	});
};

export default {
	init,
};
